import { ToggleButton, ToggleButtonGroup, Box, Typography } from '@mui/material';
import { response as responseTokens } from '../../theme/tokens';

/**
 * The single scoring control: Yes / Emerging / No.
 *
 * Replaces a 3-radio group. Radios are small targets with a label to one side —
 * fine at a desk, poor on a tablet held in one hand, and they gave no visual
 * summary of a row's state. A segmented control is one tap, ≥44px, and reads
 * as filled-or-not at a glance.
 *
 * Values match what the API stores: Y = 2, I (emerging) = 1, N = 0.
 */

export const SCORES = [
  { value: 2, key: 'Y', label: 'Yes', hint: 'Observed' },
  { value: 1, key: 'I', label: 'Emerging', hint: 'Developing' },
  { value: 0, key: 'N', label: 'No', hint: 'Not observed' },
];

const ScoreControl = ({ label, value, onChange, onFocus, active = false, size = 'medium' }) => (
  <Box>
    {label && (
      <Typography
        variant="caption"
        sx={{ display: 'block', mb: 0.5, fontWeight: 600, color: active ? 'primary.main' : 'text.secondary' }}
      >
        {label}
      </Typography>
    )}
    <ToggleButtonGroup
      exclusive
      size={size}
      value={value ?? null}
      onChange={(_, next) => { if (next !== null) onChange(next); }}
      onFocus={onFocus}
      aria-label={label}
      sx={{
        width: '100%',
        '& .MuiToggleButton-root': {
          flex: 1,
          minHeight: size === 'small' ? 36 : 44,
          textTransform: 'none',
          fontWeight: 600,
          borderColor: 'divider',
          color: 'text.secondary',
          px: 1,
        },
      }}
    >
      {SCORES.map((s) => {
        const tone = responseTokens[s.key];
        return (
          <ToggleButton
            key={s.value}
            value={s.value}
            aria-label={s.label}
            sx={{
              '&.Mui-selected': {
                bgcolor: tone.light,
                color: tone.main,
                borderColor: tone.main,
                '&:hover': { bgcolor: tone.light },
              },
            }}
          >
            {/* Full word where there's room, initial where there isn't — the
                meaning is never carried by colour alone. */}
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>{s.label}</Box>
            <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>{s.key}</Box>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  </Box>
);

export default ScoreControl;
